// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import procurementEntity from './entities/procurement.json';
import procurementMenu from '../pages/procurement/menu.json';
import procurementFullForm from '../pages/procurement/forms/full.json';
import procurementContextForm from '../pages/procurement/forms/context.json';
import procurementMiniForm from '../pages/procurement/forms/mini.json';
import procurementLookupForm from '../pages/procurement/forms/lookup.json';
import procurementTableView from '../pages/procurement/views/table.json';
import procurementStagesView from '../pages/procurement/views/stages.json';
import procurementCardsView from '../pages/procurement/views/cards.json';
import procurementInlineView from '../pages/procurement/views/inline.json';
import procurementBacklogView from '../pages/procurement/views/backlog.json';
import procurementSplitView from '../pages/procurement/views/split.json';
import procurementCalendarView from '../pages/procurement/views/calendar.json';
import procurementDashboardView from '../pages/procurement/views/dashboard.json';

/** Тип запису «Закупівля» зі сторінками пакета: меню, форми та подання з pages/procurement/. */
export const procurementDefinition: IRecordTypeDefinition = {
  ...procurementEntity,
  views: assembleViewSet({
      table: procurementTableView,
      stages: procurementStagesView,
      cards: procurementCardsView,
      inline: procurementInlineView,
      backlog: procurementBacklogView,
      split: procurementSplitView,
      calendar: procurementCalendarView,
      dashboard: procurementDashboardView,
  }),
  form: procurementFullForm,
  forms: { full: procurementFullForm, context: procurementContextForm, mini: procurementMiniForm, lookup: procurementLookupForm },
  menu: procurementMenu,
} as IRecordTypeDefinition;
